/* Offer / thank-you page (op-*): checkout-link fill, countdown, VSL sound
   overlay, scrolling testimonial wall. Config comes from the hero section's
   <script id="op-offer-config"> (defaults below if the hero is removed). */
(function () {
  'use strict';

  var cfg = { checkout_url: '', timer: { hours: 72, key: 'op-offer-deadline' } };
  try {
    var el = document.getElementById('op-offer-config');
    if (el) {
      var parsed = JSON.parse(el.textContent);
      cfg.checkout_url = parsed.checkout_url || '';
      cfg.cart_variant = parsed.cart_variant || '';
      cfg.return_to = parsed.return_to || '';
      cfg.deadline_funnel = !!parsed.deadline_funnel;
      if (parsed.timer) {
        cfg.timer.hours = parseFloat(parsed.timer.hours) || 72;
        cfg.timer.key = parsed.timer.key || cfg.timer.key;
      }
    }
  } catch (e) { /* keep defaults */ }

  /* ---------- CTAs without their own URL inherit the hero's offer ----------
     cart mode: swap each inheriting link for the same plain POST /cart/add form the hero renders */
  var inheritors = document.querySelectorAll('a[data-op-checkout="inherit"]');
  if (cfg.cart_variant) {
    inheritors.forEach(function (a) {
      var form = document.createElement('form');
      form.method = 'post'; form.action = '/cart/add'; form.className = 'op-cta-form';
      form.setAttribute('accept-charset', 'UTF-8'); form.enctype = 'multipart/form-data';
      var fields = { id: cfg.cart_variant, quantity: '1' };
      if (cfg.return_to) fields.return_to = cfg.return_to;
      Object.keys(fields).forEach(function (k) {
        var i = document.createElement('input'); i.type = 'hidden'; i.name = k; i.value = fields[k]; form.appendChild(i);
      });
      var btn = document.createElement('button');
      btn.type = 'submit'; btn.className = a.className; btn.setAttribute('data-op-cta', a.getAttribute('data-op-cta') || '');
      while (a.firstChild) btn.appendChild(a.firstChild);
      form.appendChild(btn);
      a.replaceWith(form);
    });
  } else if (cfg.checkout_url) {
    inheritors.forEach(function (a) { a.setAttribute('href', cfg.checkout_url); });
  }

  /* ---------- countdown (built-in mode) ---------- */
  var timers = document.querySelectorAll('[data-op-timer-value]');
  if (timers.length && !cfg.deadline_funnel) {
    var deadline;
    try {
      deadline = parseInt(localStorage.getItem(cfg.timer.key) || '', 10);
      if (!deadline || deadline < Date.now() - 864e5 * 30) {
        deadline = Date.now() + cfg.timer.hours * 3600e3;
        localStorage.setItem(cfg.timer.key, String(deadline));
      }
    } catch (e) {
      deadline = Date.now() + cfg.timer.hours * 3600e3;
    }
    var pad = function (n) { return String(n).padStart(2, '0'); };
    var tick = function () {
      var left = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
      var txt = Math.floor(left / 86400) + 'd ' + pad(Math.floor(left % 86400 / 3600)) + 'h ' + pad(Math.floor(left % 3600 / 60)) + 'm ' + pad(left % 60) + 's';
      timers.forEach(function (t) {
        t.textContent = txt;
        var pill = t.closest('[data-op-timer]');
        if (pill) pill.classList.toggle('is-expired', left === 0);
      });
      return left;
    };
    if (tick() > 0) {
      var iv = setInterval(function () { if (tick() === 0) clearInterval(iv); }, 1000);
    }
  }

  /* ---------- VSL: click-to-unmute overlay ---------- */
  var vimeoApi = null;
  var loadVimeoApi = function () {
    if (window.Vimeo && window.Vimeo.Player) return Promise.resolve(window.Vimeo);
    if (vimeoApi) return vimeoApi;
    vimeoApi = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = 'https://player.vimeo.com/api/player.js';
      s.async = true;
      s.onload = function () { resolve(window.Vimeo); };
      s.onerror = reject;
      document.head.appendChild(s);
    });
    return vimeoApi;
  };
  var srcUnmute = function (iframe) {
    iframe.src = iframe.src.replace(/([?&])muted=1/, '$1muted=0').replace(/([?&])autoplay=0/, '$1autoplay=1');
  };
  document.querySelectorAll('[data-op-unmute]').forEach(function (btn) {
    var iframe = btn.parentElement.querySelector('iframe');
    if (!iframe) return;
    // warm the API after load so the click can unmute in place
    window.addEventListener('load', function () { setTimeout(function () { loadVimeoApi().catch(function () {}); }, 1500); });
    btn.addEventListener('click', function () {
      btn.remove();
      var done = false;
      var fallback = setTimeout(function () { if (!done) srcUnmute(iframe); }, 2500);
      loadVimeoApi().then(function (Vimeo) {
        var p = new Vimeo.Player(iframe);
        // unmute first (instant); the restart-from-0 seek can be slow and must not trip the fallback
        return p.setMuted(false)
          .then(function () { return p.setVolume(1); })
          .then(function () { done = true; clearTimeout(fallback); return p.setCurrentTime(0); })
          .then(function () { return p.play(); });
      }).catch(function () { clearTimeout(fallback); if (!done) { done = true; srcUnmute(iframe); } });
    });
  });

  /* ---------- testimonial wall ---------- */
  document.querySelectorAll('[data-op-wall]').forEach(function (wall) {
    var viewport = wall.querySelector('.op-wall__viewport');
    var source = Array.prototype.slice.call(viewport.querySelectorAll('.op-comment'));
    if (!source.length) return;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var SPEEDS = [38, 50, 32];
    var tracks = [], halves = [], off = [0, 0, 0];
    var speed = 1, ramp = 0, hovering = false, visible = false, raf = 0, last = 0, ncols = 0;

    var colsFor = function (w) { return w < 720 ? 1 : w < 1000 ? 2 : 3; };
    var build = function () {
      var n = colsFor(window.innerWidth);
      if (n === ncols) return;
      ncols = n; tracks = []; halves = []; off = [0, 0, 0];
      viewport.textContent = '';
      for (var c = 0; c < n; c++) {
        var col = document.createElement('div'); col.className = 'op-wall__col';
        var track = document.createElement('div'); track.className = 'op-wall__track';
        var mine = source.filter(function (_, i) { return i % n === c; });
        mine.forEach(function (card) { track.appendChild(card.cloneNode(true)); });
        if (!reduced) mine.forEach(function (card) {
          var dup = card.cloneNode(true); dup.setAttribute('aria-hidden', 'true'); track.appendChild(dup);
        });
        col.appendChild(track); viewport.appendChild(col); tracks.push(track);
      }
      viewport.classList.add('is-ready');
      if (reduced) viewport.style.overflowY = 'auto';
    };

    var frame = function (now) {
      var dt = Math.min(64, now - last) / 1000; last = now;
      var target = hovering ? 0 : speed;
      ramp += (target - ramp) * Math.min(1, dt * 3);
      tracks.forEach(function (t, i) {
        var half = halves[i] || (halves[i] = t.scrollHeight / 2);
        if (!half) return;
        off[i] = (off[i] + SPEEDS[i % 3] * ramp * dt) % half;
        t.style.transform = 'translateY(' + (-off[i]) + 'px)';
      });
      raf = visible ? requestAnimationFrame(frame) : 0;
    };
    var start = function () { if (!raf && !reduced && visible) { last = performance.now(); raf = requestAnimationFrame(frame); } };

    build();
    var rt;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { var before = ncols; build(); if (ncols === before) halves = []; }, 150); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { halves = []; });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        visible = es.some(function (x) { return x.isIntersecting; });
        if (visible) start();
      }, { threshold: 0.05 }).observe(wall);
    } else { visible = true; start(); }

    wall.addEventListener('mouseenter', function () { hovering = true; });
    wall.addEventListener('mouseleave', function () { hovering = false; });

    var section = wall.closest('.op-testi') || document;
    section.querySelectorAll('[data-op-speed]').forEach(function (b) {
      b.addEventListener('click', function () {
        speed = parseFloat(b.getAttribute('data-op-speed'));
        section.querySelectorAll('[data-op-speed]').forEach(function (o) { o.setAttribute('aria-pressed', String(o === b)); });
        start();
      });
    });
  });
})();

/* ---------- UTN opt-in: every [data-utn-alia] opens the Alia popup ---------- */
(function () {
  'use strict';
  var campaign = '';
  try { var c = document.getElementById('utn-config'); if (c) campaign = String(JSON.parse(c.textContent).alia_campaign || ''); } catch (e) {}
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[data-utn-alia]');
    if (!el) return;
    e.preventDefault();
    var id = el.getAttribute('data-alia-campaign') || campaign;
    if (!id) return;
    window.alia = window.alia || [];
    window.alia.push({ type: 'open', campaignID: Number(id), ignoreTargeting: true });
  });
})();
